import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import { CircularProgress } from "@material-ui/core";
import clsx from "clsx";
import TextField from "@material-ui/core/TextField";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import FormControl from "@material-ui/core/FormControl";
import MailOutlineOutlinedIcon from "@material-ui/icons/MailOutlineOutlined";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { HOST_URL, basename, LOCAL_STORAGE_KEY } from "../../../config";
import { setUserData, getUserData } from "../../common/utility/Utils";
import axios from "axios";
import "./scheduleSignUp.css";
import MainLayout from "../../common/Layout/MainLayout";
import routeConstant from "../../../route/compoent/routeConstant";

const useStyles = makeStyles((theme) => ({
  margin: {
    margin: theme.spacing(1)
  },
  withoutLabel: {
    marginTop: theme.spacing(3)
  }
}));

function ScheduleLogin() {
  const classes = useStyles();
  const [email, setEmail] = useState("");
  // const history = useHistory();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [values, setValues] = useState({
    password: "",
    showPassword: false
  });
  const [openalert, setOpenalert] = useState(false);
  const [alertText, setAlertText] = useState("");
  const [severity, setSeverity] = useState("error");
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenalert(false);
  };
  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
  };
  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const onLogin = () => {
    const emailAddress = email.trim();
    if (!emailAddress) {
      setOpenalert(true);
      setSeverity("error");
      setAlertText("Please fill email address!");
    } else if (
      !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        emailAddress
      )
    ) {
      setOpenalert(true);
      setSeverity("error");
      setAlertText("Please fill correct email address!");
    } else if (!values.password) {
      setOpenalert(true);
      setSeverity("error");
      setAlertText("Please fill password!");
    } else {
      setLoading(true);
      const URL = `${HOST_URL}api/v1/TempAccountData/TmpLogin`;
      const params = {
        user_id: email,
        name_of_user: "",
        email: email,
        contact: "",
        password: values.password,
        company_code: "",
        country_code: "",
        ActionName: ""
      };
      axios
        .post(URL, params)
        .then((res) => {
          setLoading(false);
          if (res.data.result === "0") {
            setOpenalert(true);
            setSeverity("error");
            setAlertText("Invalid data!");
          } else if (res.data.result === "1") {
            res.data.username = email;
            res.data.password = values.password;
            console.log({ res });
            setUserData(res.data, LOCAL_STORAGE_KEY)
              .then(() => {
                navigate(routeConstant.SCHEDULE);
              })
              .catch(() => {
                navigate(routeConstant.SCHEDULE_LOGIN);
              });
            setOpenalert(true);
            setSeverity("success");
            setAlertText("Successfully Login!");
          }
        })
        .catch((err) => {
          setLoading(false);
          console.log(err);
          setOpenalert(true);
          setSeverity("error");
          setAlertText("Something went wrong!");
        });
    }
  };

  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

  return (
    <div className="scheduleSignUpComp">
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={openalert}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert severity={severity} onClose={handleClose}>
          {alertText}
        </Alert>
      </Snackbar>
      <div className="scheduleSignUpCompBody">
        <div className="scheduleSignUpCompBodyInner">
          <img
            src={`/${basename}/Assets/Images/mtslogo.svg`}
            alt="mtsFavIcon"
          />
          <div className="userId">
            <FormControl className={clsx(classes.margin, classes.textField)}>
              <TextField
                id="standard-basic"
                label={
                  <span className="loginLabelSpan">
                    <MailOutlineOutlinedIcon /> Enter your registered email
                    address
                  </span>
                }
                value={email}
                type="text"
                onChange={(e) => {
                  setEmail(e.target.value);
                }}
              />
            </FormControl>
          </div>
          <div className="userPassword">
            <FormControl className={clsx(classes.margin, classes.textField)}>
              <InputLabel htmlFor="password">
                <span className="loginLabelSpan">
                  <LockOutlinedIcon /> Password
                </span>
              </InputLabel>
              <Input
                id="password"
                type={values.showPassword ? "text" : "password"}
                value={values.password}
                onChange={handleChange("password")}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                    >
                      {values.showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>
          </div>
          <div className="forgotPass">
            <span
              className="pointer"
              onClick={() => navigate(routeConstant.SCHEDULE_FORGOT_PASSWORD)}
            >
              Forgot Password
            </span>
          </div>
          <div className="loginButton">
            <Button variant="contained" onClick={() => onLogin()}>
              {loading ? <CircularProgress size="1.5rem" /> : "Login"}
            </Button>
          </div>
          <div className="scheduleSignUplinkDiv">
            <p>
              Don't have an account?{" "}
              <span
                className="pointer"
                onClick={() => {
                  navigate(routeConstant.SCHEDULE_SIGNUP);
                }}
              >
                Sign Up
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ScheduleLogin;
